module.exports = __webpack_public_path__ + "static/media/bottom-cover.3b88a124.svg";